import React from "react";

const TeacherFormInput = ({
  label,
  value,
  onChange,
  rows = 1,
  isRequired = false,
}) => {
  return (
    <div className="form-group_new">
      <label>{label}</label>
      <textarea
        value={value}
        onChange={onChange}
        rows={rows}
        required={isRequired}
      />
    </div>
  );
};

export default TeacherFormInput;
